import { PRODUCT_SELECT_ALL, PRODUCT_DESELECT_ALL } from '../../../ActionsConst';

export const productSelectAllAction = () => ({
  type: PRODUCT_SELECT_ALL,
});

export const productDeselectAllAction = () => ({
  type: PRODUCT_DESELECT_ALL,
});
